import { Port } from '../../../maritime-menu-options/world-ports-panel/world-ports.model';
import {
  cellBaseStyle,
  tableHeaderColour,
  tableHeaderTextColour,
  tableWidth,
} from '../pro-report-email-styles';

function ProReportEmailDestinationPort({ port }: { port: Port }) {
  return (
    <table
      width={tableWidth}
      cellPadding={0}
      cellSpacing={0}
      style={{
        borderCollapse: 'collapse',
        margin: 0,
        padding: 0,
      }}
      role="presentation"
    >
      <tr>
        <td
          style={{
            ...cellBaseStyle,
            backgroundColor: tableHeaderColour,
            color: tableHeaderTextColour,
            fontWeight: 'bold',
          }}
        >
          Destination port:
        </td>
        <td
          style={{
            ...cellBaseStyle,
          }}
        >
          {[
            port.NAME,
            port.COUNTRY,
            port.UNLOCODE ? `(UNLOCODE: ${port.UNLOCODE})` : null,
          ]
            .filter(Boolean)
            .join(', ')}
        </td>
      </tr>
    </table>
  );
}

export default ProReportEmailDestinationPort;
